export default __webpack_public_path__ + "scripts/resource/2618b341a96911d5b0c55ffab6e28de6.svg";